import { setupAccordions } from '$c3base/accordion.js';

$(function () {
    setupAccordions('.accordion');
});

$(window).on('load', function (e) {

});

$(window).on('resize', function (e) {

});

$(window).on('resize scroll', function() {
    $('.frame .counter:not(.done)').each(function() {
        const speed = $(this).data('speed');

        if ($(this).visible()) {
            $(this).find('.counter-item-number').each(function() {
                const end = $(this).data('number');
                const unit = $(this).data('unit') || '';
                const prefix = $(this).data('prefix') || '';

                animateValue(this, 0, end, prefix, unit, speed);
            });

            $(this).addClass('done');
        }
    });
});

function animateValue(obj, start, end, prefix, unit, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
        if (!startTimestamp)
            startTimestamp = timestamp;

        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        obj.innerHTML = '<span class="prefix">' + prefix + '</span>' + Math.floor(progress * (end - start) + start) + unit;

        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };

    window.requestAnimationFrame(step);
}